// TODO(mat): pls help to type this if possible (take a look at the useMultiNodes where we need to pass additional args to the callback)
// a small util to avoid using `immer`'s imperative api
type Callback<T extends any[]> = (fn: (props: any) => void, ...args: T) => void;

export const immerToES6 = <T extends any[]>(callback: Callback<T>) => (
  values: Record<string, unknown>,
  ...args: T
) => {
  callback((props: Record<string, unknown>) => {
    Object.entries(values).forEach(([key, value]) => {
      // eslint-disable-next-line no-param-reassign
      props[key] = value;
    });
  }, ...args);
};
